import Marquee from 'react-fast-marquee';
import { sectionStyles } from '../utils';

const SPEEDS = { slow: 30, normal: 50, fast: 80 };
const SEPARATORS = {
    dot: '\u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0',
    star: '\u00A0\u00A0\u00A0\u2605\u00A0\u00A0\u00A0',
    diamond: '\u00A0\u00A0\u00A0\u25C6\u00A0\u00A0\u00A0',
    dash: '\u00A0\u00A0\u00A0\u2014\u00A0\u00A0\u00A0',
    slash: '\u00A0\u00A0\u00A0/\u00A0\u00A0\u00A0',
    pipe: '\u00A0\u00A0\u00A0|\u00A0\u00A0\u00A0',
    arrow: '\u00A0\u00A0\u00A0\u2192\u00A0\u00A0\u00A0',
    plus: '\u00A0\u00A0\u00A0+\u00A0\u00A0\u00A0',
};

export default function MarqueeTextSection({ block = {}, primaryColor, secondaryColor }) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor);
    const text = content.text || '';
    const speed = SPEEDS[config.speed] || SPEEDS.normal;
    const separator = SEPARATORS[config.separator] || SEPARATORS.dot;
    const direction = config.direction === 'right' ? 'right' : 'left';
    const variant = config.variant || 'simple';
    const accentSep = config.accent_separator !== false;

    if (!text) return null;

    const bgS = s.bgStyle.background ? s.bgStyle : { backgroundColor: s.bg || '#ffffff', ...s.bgStyle };

    // Build repeated text with styled separators
    const segments = text.split(' - ').length > 1 ? text.split(' - ') : [text];
    const buildTrack = () => segments.map((seg, i) => (
        <span key={i}>
            <span style={{ color: s.text }}>{seg.trim()}</span>
            {i < segments.length - 1 || true ? (
                <span style={{ color: accentSep ? (config.accent_color || primaryColor) : s.text, opacity: accentSep ? 1 : 0.3 }}>{separator}</span>
            ) : null}
        </span>
    ));

    // ── Outlined variant (stroke text) ──
    if (variant === 'outlined') {
        const repeated = `${text}${separator}${text}${separator}${text}${separator}${text}${separator}`;
        return (
            <section className="relative overflow-hidden py-6 md:py-8" style={bgS}>
                <Marquee speed={speed} pauseOnHover gradient={false} direction={direction}>
                    <span className="text-3xl md:text-5xl font-black tracking-wider uppercase shrink-0 pr-8"
                        style={{ WebkitTextStroke: `2px ${s.text}`, WebkitTextFillColor: 'transparent' }}>
                        {repeated}
                    </span>
                </Marquee>
            </section>
        );
    }

    // ── Large variant (big bold text) ──
    if (variant === 'large') {
        return (
            <section className="relative overflow-hidden py-8 md:py-10" style={bgS}>
                <Marquee speed={speed} pauseOnHover gradient={false} direction={direction}>
                    <span className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tight uppercase shrink-0 pr-12" style={{ color: s.text }}>
                        {segments.map((seg, i) => (
                            <span key={i}>
                                {seg.trim()}
                                <span className="inline-block mx-4 md:mx-8 text-2xl md:text-4xl align-middle" style={{ color: config.accent_color || primaryColor }}>
                                    {config.separator === 'star' ? '★' : config.separator === 'diamond' ? '◆' : '•'}
                                </span>
                            </span>
                        ))}
                    </span>
                </Marquee>
            </section>
        );
    }

    // ── Simple (default) ──
    const repeated = `${text}${separator}${text}${separator}${text}${separator}${text}${separator}`;
    return (
        <section className="relative overflow-hidden py-5 md:py-6" style={bgS}>
            <Marquee speed={speed} pauseOnHover gradient={false} direction={direction}>
                <span className="text-lg md:text-2xl font-bold tracking-wide uppercase shrink-0 pr-8" style={{ color: s.text }}>
                    {repeated}
                </span>
            </Marquee>
        </section>
    );
}
